import React from "react";
import { Button, Typography } from "@mui/material";
import manWomanBoxes from "assets/supergasbras/images/manWomanBoxes.svg";

import { useTranslation } from "react-i18next";
import * as Styled from "./styles";

interface CardFluidHeaderProps {
  title: string;
  titleButton: string;
  onClick?: () => void;
  modal?: any;
  isButton?: boolean;
}

const CardFluidHeader = ({
  title,
  titleButton,
  modal,
  isButton,
  onClick,
}: CardFluidHeaderProps) => {
  const { t } = useTranslation();
  const handleAddNewAreaModalVisibility = () => {
    onClick?.();
  };

  return (
    <Styled.Container>
      {modal}
      <Styled.Image src={manWomanBoxes} aria-label={t("manWomanBoxes")} />
      <Typography variant="h5">{title}</Typography>
      {isButton && (
        <Button
          sx={{ marginLeft: "auto" }}
          variant="outlined"
          onClick={handleAddNewAreaModalVisibility}
        >
          {titleButton}
        </Button>
      )}
    </Styled.Container>
  );
};

export default CardFluidHeader;
